import { createContext, FC, PropsWithChildren, useContext, useState } from 'react';

type ActiveRowContextValue = string | false;

const activeRowContext = createContext<ActiveRowContextValue>(false);

export const ActiveRowProvider: FC<PropsWithChildren<{ value: ActiveRowContextValue }>> = ({
  value,
  children,
}) => <activeRowContext.Provider value={value}>{children}</activeRowContext.Provider>;

export const useActiveRowContext = () => useContext(activeRowContext);

export const useActiveRowState = (
  defaultValue: ActiveRowContextValue = false,
  disable?: boolean,
) => {
  const state = useState<ActiveRowContextValue>(defaultValue);
  return disable ? ([false, state[1]] as const) : state;
};
